export const lastOrDefault = (source, predicate) => {
    if (predicate) {
        return lastOrDefault2(source, predicate);
    }
    else {
        return lastOrDefault1(source);
    }
};
const lastOrDefault1 = (source) => {
    let last = null;
    for (const value of source) {
        last = value;
    }
    return last;
};
const lastOrDefault2 = (source, predicate) => {
    let last = null;
    for (const value of source) {
        if (predicate(value) === true) {
            last = value;
        }
    }
    return last;
};
